/**
 * section-sw-journey-selector.js — vanilla JS two-tier Series -> Chassis
 * selector (SW journey lane). Promotes the dependent-dropdown INTERACTION
 * PATTERN used by product-info.js (state-array + resolve-on-change), but this
 * component is a NAVIGATIONAL picker, not a variant picker: selecting a
 * chassis in the second dropdown navigates straight to that chassis's
 * Search & Discovery filtered collection URL — confirmed live 2026-07-13
 * against /collections/bmw-badge (filter.p.m.custom.chassis facet).
 *
 * Multiple independent instances can exist on one page (the header desktop
 * panel, the header mobile-drawer entry, and the full chassis-selector
 * section on /pages/choose-your-bmw) — each `[data-sw-chassis-selector]` root
 * is initialized independently. All instances share ONE data source: the
 * hidden JSON blob rendered once by sections/header.liquid via
 * `{% render 'chassis-data', mode: 'json' %}` (snippets/chassis-data.liquid),
 * read here via `document.getElementById('sw-chassis-data')` so the ~12KB
 * payload never ships twice on the same page.
 *
 * No GSAP. No frameworks. Degrades safely: if the JSON node is missing (e.g.
 * a template renders this component without the header), the selects stay
 * empty/disabled rather than throwing.
 */
(function () {
  'use strict';

  if (window.SWJourneySelector) return;
  window.SWJourneySelector = true;

  var DEFAULT_COLLECTION = '/collections/bmw-badge';

  function readChassisData() {
    if (window.__swChassisData) return window.__swChassisData;
    var node = document.getElementById('sw-chassis-data');
    if (!node) return null;
    try {
      window.__swChassisData = JSON.parse(node.textContent);
    } catch (error) {
      window.__swChassisData = null;
    }
    return window.__swChassisData;
  }

  function populateSeries(select, series) {
    var frag = document.createDocumentFragment();
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select series';
    frag.appendChild(placeholder);
    series.forEach(function (s) {
      var opt = document.createElement('option');
      opt.value = s.id;
      opt.textContent = s.name;
      frag.appendChild(opt);
    });
    select.innerHTML = '';
    select.appendChild(frag);
  }

  function populateChassis(select, chassisList, placeholderText) {
    var frag = document.createDocumentFragment();
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = placeholderText;
    frag.appendChild(placeholder);
    (chassisList || []).forEach(function (c) {
      var opt = document.createElement('option');
      opt.value = c.slug;
      opt.textContent = c.code + ' (' + c.years + ')';
      frag.appendChild(opt);
    });
    select.innerHTML = '';
    select.appendChild(frag);
  }

  function init(root) {
    if (root.hasAttribute('data-sw-selector-ready')) return;
    root.setAttribute('data-sw-selector-ready', '');

    var seriesSelect = root.querySelector('[data-sw-series-select]');
    var chassisSelect = root.querySelector('[data-sw-chassis-select]');
    if (!seriesSelect || !chassisSelect) return;

    var targetCollection = root.getAttribute('data-target-collection') || DEFAULT_COLLECTION;
    var data = readChassisData();

    if (!data || !data.series || !data.series.length) {
      chassisSelect.disabled = true;
      return; // no data yet — fail quiet, never throw on a nav-only widget
    }

    populateSeries(seriesSelect, data.series);
    chassisSelect.disabled = true;
    populateChassis(chassisSelect, [], 'Select series first');

    seriesSelect.addEventListener('change', function () {
      var seriesId = seriesSelect.value;
      var series = data.series.filter(function (s) {
        return s.id === seriesId;
      })[0];
      if (!series) {
        chassisSelect.disabled = true;
        populateChassis(chassisSelect, [], 'Select series first');
        return;
      }
      chassisSelect.disabled = false;
      populateChassis(chassisSelect, series.chassis, 'Select chassis');
    });

    chassisSelect.addEventListener('change', function () {
      var slug = chassisSelect.value;
      if (!slug) return;
      window.location.href = targetCollection + '?filter.p.m.custom.chassis=' + encodeURIComponent(slug);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sw-chassis-selector]').forEach(init);
  }

  /* ----- header compact panel toggle (button + popover) ----- */
  function initHeaderPanel() {
    var trigger = document.querySelector('[data-sw-journey-toggle]');
    var panel = document.querySelector('[data-sw-journey-panel]');
    if (!trigger || !panel || trigger.hasAttribute('data-sw-journey-ready')) return;
    trigger.setAttribute('data-sw-journey-ready', '');

    function close() {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }
    function open() {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    trigger.addEventListener('click', function (event) {
      event.stopPropagation();
      if (panel.hidden) {
        open();
      } else {
        close();
      }
    });
    document.addEventListener('click', function (event) {
      if (!panel.hidden && !panel.contains(event.target) && event.target !== trigger) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        close();
        trigger.focus();
      }
    });
  }

  function boot(scope) {
    initAll(scope);
    initHeaderPanel();
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  }
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
